import { jt, t } from "ttag";

import { ExternalLink } from "metabase/common/components/ExternalLink/ExternalLink";
import { UpsellWrapperDismissible } from "metabase/common/components/upsells/components/UpsellBannerDismissible";
import { UpsellGem } from "metabase/common/components/upsells/components/UpsellGem";
import { useDocsUrl } from "metabase/common/hooks/use-docs-url/use-docs-url";
import { ActionIcon, Alert, Box, Flex, Icon, Text } from "metabase/ui";

export const DevInstanceUpsell = UpsellWrapperDismissible(
  function DevInstanceUpsell({ onDismiss }: { onDismiss?: () => void }) {
    // eslint-disable-next-line metabase/no-unconditional-metabase-links-render -- This link only shows for admins.
    const { url: devInstanceDocsUrl } = useDocsUrl(
      "installation-and-operation/development-instance",
    );
    return (
      <Alert color="core-brand">
        <Flex align="flex-start" gap="sm">
          <UpsellGem.New mt="0.125rem" />
          <Box ml="sm" style={{ flex: 1 }}>
            <Text fw="bold">{t`Need a dedicated development environment?`}</Text>
            <Text lh="1.25rem">
              {jt`With ${(
                <ExternalLink
                  key="link"
                  href={devInstanceDocsUrl}
                >{t`Development instances`}</ExternalLink>
              )}, you can build and test your changes in a safe, isolated environment before syncing to production.`}
            </Text>
          </Box>
          {onDismiss && (
            <ActionIcon
              aria-label={t`Dismiss`}
              onClick={onDismiss}
              variant="transparent"
              size="sm"
            >
              <Icon
                name="close"
                size={16}
                aria-hidden
                aria-label={undefined}
                role="presentation"
              />
            </ActionIcon>
          )}
        </Flex>
      </Alert>
    );
  },
);
